import {ReactNode} from 'react'
import {DrawerComponent, MenuComponent, ToggleComponent} from '../assets/ts/components'

type WithChildren = {
  children?: ReactNode
}

const reInitMenu = () => {
  setTimeout(() => {
    MenuComponent.reinitialization()
    // DrawerComponent.reinitialization()
    // ToggleComponent.reinitialization()
  }, 500)
}

export {type WithChildren, reInitMenu}
